module.exports = __webpack_public_path__ + "img/AirPods_1.92c6e88e.png";